import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b8fa72a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "highlights-list" }
const _hoisted_2 = { class: "list-unstyled" }
const _hoisted_3 = { class: "visual" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "text-area" }
const _hoisted_6 = {
  key: 1,
  class: "text"
}
const _hoisted_7 = {
  key: 2,
  class: "relation-text"
}

import { computed } from 'vue'
import { useFamilyHighlights } from './FamilyHighlights'
import { useExploreStore } from '@/explore/ExploreStore'
import { ViewPerson } from '@/rd/ResearchDataModel'
import { useViewPersonStore } from '@/rd/ViewPersonStore'
import { useRelationTextBuilder } from '@/rd/RelationPath'
import { shuffle } from 'lodash'


export default /*#__PURE__*/_defineComponent({
  __name: 'HighlightsList',
  setup(__props) {

const exploreStore = useExploreStore()
const viewPersonStore = useViewPersonStore()
const { treeHighlightsRef } = useFamilyHighlights()
const { getRelationText } = useRelationTextBuilder()

const highlightsRef = computed(() => {
  const allHighlights = treeHighlightsRef.value
  const selectedHighlights = shuffle(allHighlights).slice(0, 4)

  for (const item of selectedHighlights) {
    if (exploreStore.startPersonId && item.personId) {
      item.relationPath = viewPersonStore.getLoadedRelationPath(exploreStore.startPersonId, item.personId)
    }
  }
  return selectedHighlights
})

function getNumberFontSize(value: number) {
  if (value < 100) {
    return '2rem'
  } else if (value < 1000) {
    return '1.3rem'
  } else {
    return '1.1rem'
  }
}


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(highlightsRef.value, (h) => {
        return (_openBlock(), _createElementBlock("li", {
          key: h.id
        }, [
          _createElementVNode("div", _hoisted_3, [
            (h.image)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: h.image
                }, null, 8, _hoisted_4))
              : _createCommentVNode("", true),
            (typeof h.value == 'number')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "big-text",
                  style: _normalizeStyle({ fontSize: getNumberFontSize(h.value) })
                }, _toDisplayString(h.value), 5))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_5, [
            (h.personId)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: _unref(ViewPerson).getPageUrl(h.personId),
                  class: "link-dark text"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(h.text), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(h.text), 1)),
            (h.relationPath)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, "your " + _toDisplayString(_unref(getRelationText)(h.relationPath)), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})